const buildUserUrl = (id: number) => `/users/${id}`;

export default buildUserUrl;
